/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartMarqueeCircular = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19.982 16v6h-6v-6zM9.089 19.461c.567.22 1.16.375 1.763.46l-.28 1.98a9.953 9.953 0 0 1-2.206-.575zM17.982 18h-2v2h2zM5.518 16.713c.357.49.773.941 1.235 1.342l-1.308 1.511a10.034 10.034 0 0 1-1.543-1.675zm-1.521-4.239c.035.608.14 1.213.312 1.795l-1.918.566A9.982 9.982 0 0 1 2 12.589zm17.986-.51V12c0 .764-.087 1.524-.258 2.263l-1.948-.45A8.097 8.097 0 0 0 19.983 12zM3.263 7.101l1.742.982a7.964 7.964 0 0 0-.706 1.679l-1.92-.559c.213-.731.51-1.438.884-2.102zm17.112-.539a9.87 9.87 0 0 1 1.015 2.042l-1.882.677a7.915 7.915 0 0 0-.81-1.63zM7.29 3.166l.94 1.766a8.025 8.025 0 0 0-1.502 1.034L5.415 4.458A10.064 10.064 0 0 1 7.29 3.166zm8.819-.277c.693.314 1.35.709 1.955 1.172l-1.218 1.585a8.012 8.012 0 0 0-1.564-.937zM11.985 2c.275 0 .55.011.823.034l-.167 1.992c-.222-.018-.436-.021-.676-.026-.384 0-.768.028-1.145.083l-.29-1.979c.48-.07.966-.079 1.455-.104z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartMarqueeCircular as ChartMarqueeCircular };
